export default __webpack_public_path__ + "static/media/exit.44955d16.svg";